import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { RedirectHomeComponent } from './redirect-home/redirect-home.component';
import { RequirePasswordUpdateGuard } from './auth/requirePasswordUpdate.guard';

const routes: Routes = [
  {
    path: 'ssologin',
    redirectTo: 'auth/ssologin',
    pathMatch: 'prefix',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'cookies-policy',
    loadChildren: () =>
      import('./cookies-policy/cookies-policy.module').then(
        (m) => m.CookiesPolicyModule
      ),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: RedirectHomeComponent,
        canActivate: [RequirePasswordUpdateGuard],
      },
      {
        path: 'jbp',
        loadChildren: () =>
          import('./pages/joint-business-plan/joint-business-plan.module').then(
            (m) => m.JointBusinessPlanModule
          ),
      },
      {
        path: 'contact-campaign',
        loadChildren: () =>
          import('./contact-campaign/contact-campaign.module').then(
            (m) => m.ContactCampaignModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'planner-old',
        loadChildren: () =>
          import('./planner/planner.module').then((m) => m.PlannerModule),
      },
      {
        path: 'planner',
        loadChildren: () =>
          import('./planner-events/planner-events.module').then(
            (m) => m.PlannerEventsModule
          ),
      },
      {
        path: 'event',
        loadChildren: () =>
          import('./event/event.module').then((m) => m.EventModule),
      },
      {
        path: 'calendar-old',
        loadChildren: () =>
          import('./calendar/calendar.module').then(
            (m) => m.CalendarMatrixModule
          ),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./calendar-events/calendar-events.module').then(
            (m) => m.CalendarEventsModule
          ),
      },
      {
        path: 'trainings',
        loadChildren: () =>
          import('./trainings/trainings.module').then((m) => m.TrainingsModule),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'localizations',
        loadChildren: () =>
          import('./localizations/localizations.module').then(
            (m) => m.LocalizationsModule
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'salons',
        loadChildren: () =>
          import('./salons/salons.module').then((m) => m.SalonsModule),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'distributors',
        loadChildren: () =>
          import('./distributors/distributors.module').then(
            (m) => m.DistributorsModule
          ),
      },
      {
        path: 'participants',
        loadChildren: () =>
          import('./participant/participant.module').then(
            (m) => m.ParticipantModule
          ),
      },
      {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
